import { WorkingDays } from '@teammood/shared/ui/working-days'
import { NotificationTime, OrganisationalUnit, SubscriptionDTO, subscriptionDTOToSubscription } from '@teammood/shared/util/core'
import { TeamForAdmin } from './team-for-admin.type'

export interface TeamForAdminDTO {
  id: string,
  name: string,
  created: string,
  notificationTime: NotificationTime,
  workingDays: WorkingDays,
  subscription: SubscriptionDTO,
  isActive: boolean,
  activeUsersCount: number,
  totalUsersCount: number,
  organization: OrganisationalUnit,
  organisationalUnits: OrganisationalUnit[],
  company: {
    id: string,
    created: number,
    name: string,
    domainNames: string[]
  },
  enabledFeatures: {
    id: string,
    enabled: boolean
  }[]
}

export function teamForAdminDTOToTeamForAdmin(teamForAdminDTO: TeamForAdminDTO): TeamForAdmin {
  return {
    ...teamForAdminDTO,
    subscription: subscriptionDTOToSubscription(teamForAdminDTO.subscription)
  }
}


